export default function hasAlreadyConsented (category = 'statistics') {
	if (document.body.classList.contains('neos-backend')) {
		return true;
	}
    // We need to check if the cookie is already available, as the _necessary_ category is always true
    // even when the user did not click the cookie banner yet
    if (category === 'necessary') {
        return localStorage.hasOwnProperty('ccm_consent') || document.cookie.indexOf('ccm_consent') > -1
    }

    return window.Clickskeks && window.Clickskeks.getCurrentAllowedConfig()[category];
}
